import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ShieldCheck, Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe reinitialise. Connectez-vous.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-teal-500/20">
            <ShieldCheck className="h-5 w-5 text-teal-500" />
          </div>
          <span className="font-display text-lg font-extrabold text-slate-900">Scolaris <span className="text-teal-600">Central</span></span>
        </div>
        <h2 className="font-display text-2xl font-bold text-slate-900">Nouveau mot de passe</h2>
        <p className="text-sm text-slate-500 mt-1">Choisissez un nouveau mot de passe securise.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="password">Nouveau mot de passe</Label>
            <Input id="password" data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={12} className="mt-1.5" />
          </div>
          {error && <p className="text-sm text-rose-600">{error}</p>}
          <Button type="submit" data-testid="reset-submit" disabled={loading || !token} className="w-full bg-teal-600 hover:bg-teal-700">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reinitialiser"}
          </Button>
        </form>
        <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-teal-600">
          <ArrowLeft className="h-4 w-4" /> Retour a la connexion
        </Link>
      </div>
    </div>
  );
}
